import styled from 'styled-components';

export const ReportSectionSmallControls = styled.span`
    button {
        min-width: 0;
        font-size: 1rem;
    }
`;
ReportSectionSmallControls.displayName = 'ReportSectionSmallControls';
